// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"8606a926","165":"f700b985","453":"81a083ea","510":"b37caa44","548":"d2858af6"}[chunkId] + ".chunk.js";
};